module.exports = __webpack_public_path__ + "static/media/to.00aaa22b.svg";